// TODO: break this file out into different model files for better organization

import {merge as _merge} from "lodash-es";

// EventifyAPI
import * as UserContext from "./UserContext";

import config from "../config";

// UUID
const uuidv4 = require('uuid/v4');

const EventifyStages = {
  mz: {
    root: config.devApiUrl
  },
  dev: {
    root: config.prodApiUrl
  }
}

const EventifyRouter = {
  nexus: "nexus"
}

export const EventifyAPIConstants = {
  person: {
    nexus: "/person/nexus",
    getPersonByEmail: "/person/getPersonByEmail",
    getPersonById: "/person/getPersonById",
    createIfNotExist: "/person/createIfNotExist",
    getAllPeople: "/person/getAllPeople",
    searchPersonsByNameOrEmail: "/person/searchPersonsByNameOrEmail",
    getListsForPersonId: "/person/getListsForPersonId",
    getOwnerForPersonId: "/person/getOwnerForPersonId",
    getNotesforPersonId: "/person/getNotesforPersonId",
    createMultiplePeopleIfNotExist: "/person/createMultiplePeopleIfNotExist",
    updateNameForContact: "/person/updateNameForContact"
  },
  event: {
    getById: "/event/getEventById",
    add: "/event/addEvent"
  },
  affinityProxy: {
    person: "/affinityproxy/person",
    default: "/affinityproxy/default"
  },
  list: {
    nexus: "/list/nexus",
    getAllLists: "/list/getAllLists",
    createList: "/list/createList/",
    addListToList: "/list/addListToList",
    getListById: "/list/getListById",
    getMembershipForListId: "/list/getMembershipForListId",
    getFullMembershipForListId: "/list/getFullMembershipForListId",
    getNotesForPersonInList: "/list/getNotesForPersonInList",
    addMultiplePeopleToList: "/list/addMultiplePeopleToList",
    addNotesToMultiplePersonInList: "/list/addNotesToMultiplePersonInList",
    deleteList: "/list/deleteList",
    setPrimaryDateForList: "/list/setPrimaryDateForList",
    setPropertyOfList: "/list/setPropertyOfList",
    setMultipleYNP: "/list/setMultipleYNP",
    setEviteCard: "/list/setEviteCard",
    // TODO: move listMembership fns into their own category
    createListMembership: "/list/createListMembership",
    updateListMembership: "/list/updateListMembership"
  },
  invitedUser: {
    nexus: "/invitedUser/nexus",
    create: "/invitedUser/create",
    getByEmail: "/invitedUser/getByEmail"
  },
  user: {
    nexus: "/user/nexus",
    authenticateGoogleSignIn: "/user/authenticateGoogleSignIn",
    getUserById: "/user/getUserById",
    getAllUsers: "/user/getAllUsers"
  },
  tags: {
    nexus: "/tags/nexus",
    registerManyTags: "/tags/registerManyTags",
    getTagsForPerson: "/tags/getTagsForPerson",
    getAllTagsForLists: "/tags/getAllTagsForLists",
    getTagsForList: "/tags/getTagsForList",
    setTagsForList: "/tags/setTagsForList"
  },
  history: {
    nexus: "/history/nexus",
    getAllHistoryForOrganization: "/history/getAllHistoryForOrganization",
    getHistoryForListId: "/history/getHistoryForListId"
  }
};

var requestMetrics = {};

function countRoute(route) {
  var metricsResult = requestMetrics[route];
  if (metricsResult != null) {
    metricsResult += 1;
    requestMetrics[route] = metricsResult;
  } else {
    requestMetrics[route] = 1;
  }

  // console.log(requestMetrics);
}

function environmentSingleton() {
  if (window.location.href.indexOf('localhost') !== -1) {
    return "local";
  } else if (window.location.href.indexOf('eventifybeta.com') !== -1) {
    return "dev"
  }
  return "";
}

function getRoot(environment) {
  if (environment === "local") {
    return EventifyStages.mz.root;
  } else if (environment === "dev") {
    return EventifyStages.dev.root;
  }
}

export default function EventifyAPI() { return }

// S3 conveniences

export function encodeS3URL(baseURL) {
  return encodeURI(baseURL).replace("+","%2B");
}

function createBasicRequestData() {
  return {
    userid: UserContext.getCurrentUserId(),
    organizationid: UserContext.getCurrentOrganizationId()
  }
}

function requestTo(nexus, route, requestData) {
  return new Promise( async (resolve, reject) => {
    requestData.route = route;

    countRoute(route);

    const url = getRoot(environmentSingleton()) + nexus
    const result = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    });

    if (!result.ok) {
      reject(result.statusText);
    };
    resolve(result.json());
  });
}

//---------------------------------------------------------------------
// LIST
export async function fetchAllLists() {
  var requestData = createBasicRequestData();

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.getAllLists, requestData);
}

export async function getListById(listid) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.getListById, requestData);
}

export async function addListToList(targetListId, operationListId) {
  var requestData = createBasicRequestData();

  requestData.targetListId = targetListId;
  requestData.operationListId = operationListId;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.addListToList, requestData);
}

export async function createList(listid, listName) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;
  requestData.listName = listName;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.createList, requestData);
}

export async function deleteList(listid) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.deleteList, requestData);
}

export async function setPrimaryDateForList(listid, primaryDate) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;
  requestData.primaryDate = primaryDate;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.setPrimaryDateForList, requestData);
}

export async function setPropertyOfList(listid, commands) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;
  requestData.commands = commands;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.setPropertyOfList, requestData);
}

export async function updateListMembership(listId, updates) {
  var requestData = createBasicRequestData();

  requestData.listId = listId;
  requestData.updates = updates;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.updateListMembership, requestData);
}

export async function createListMembership(listMembership) {
  var requestData = _merge(listMembership, createBasicRequestData());

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.createListMembership, requestData);
}

export async function setMultipleYNP(ynpObjects) {
  var requestData = createBasicRequestData();

  requestData.ynp = ynpObjects;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.setMultipleYNP, requestData);
}

export async function setEviteCard(listid, fileName, eviteimagebase64, fileMIMEType) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;
  requestData.fileName = fileName;
  requestData.eviteimagebase64 = eviteimagebase64;
  requestData.fileMIMEType = fileMIMEType;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.setEviteCard, requestData);
}

export async function getS3URIContents(uri) {
  const result = await fetch(uri, {
    method: 'GET',
  });

  if (!result.ok) throw new Error(result.statusText);
  return result.text();
}

export async function addMultiplePeopleToList(memberships) {
  var requestData = createBasicRequestData();

  requestData.memberships = memberships;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.addMultiplePeopleToList, requestData);
}

export async function getMembershipForListId(listid) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.getMembershipForListId, requestData);
}

export async function getFullMembershipForListId(listid) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.getFullMembershipForListId, requestData);
}

export async function addNotesToMultiplePersonInList(notes) {
  var requestData = createBasicRequestData();

  requestData.notes = notes;

  return requestTo(EventifyAPIConstants.list.nexus, EventifyAPIConstants.list.addNotesToMultiplePersonInList, requestData);
}

export async function registerManyTags(tagList, tagToPeopleList) {
  var requestData = createBasicRequestData();

  requestData.tagList = tagList;
  requestData.tagToPeopleList = tagToPeopleList;

  return requestTo(EventifyAPIConstants.tags.nexus, EventifyAPIConstants.tags.registerManyTags, requestData);
}

export async function getAllTagsForLists(email, organizationid) {
  var requestData = createBasicRequestData();

  return requestTo(EventifyAPIConstants.tags.nexus, EventifyAPIConstants.tags.getAllTagsForLists, requestData);
}

export async function getTagsForList(listid) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;

  return requestTo(EventifyAPIConstants.tags.nexus, EventifyAPIConstants.tags.getTagsForList, requestData);
}

export async function setTagsForList(tags, listid) {
  var requestData = createBasicRequestData();

  requestData.tags = tags;
  requestData.listid = listid;

  return requestTo(EventifyAPIConstants.tags.nexus, EventifyAPIConstants.tags.setTagsForList, requestData);
}

//---------------------------------------------------------------------
// PERSON
export async function getAllPeople(email, organizationid) {
  var requestData = createBasicRequestData();

  return requestTo(EventifyAPIConstants.person.nexus, EventifyAPIConstants.person.getAllPeople, requestData);
}

export async function person_createIfNotExist(personid, addUserName, addUserEmail) {
  var requestData = createBasicRequestData();

  requestData.personid = personid;
  requestData.name = addUserName;
  requestData.email = addUserEmail;

  return requestTo(EventifyAPIConstants.person.nexus, EventifyAPIConstants.person.createIfNotExist, requestData);
}

export async function person_createMultipleIfNotExist(persons) {
  var requestData = createBasicRequestData();

  requestData.persons = persons;

  return requestTo(EventifyAPIConstants.person.nexus, EventifyAPIConstants.person.createMultiplePeopleIfNotExist, requestData);
}

export async function updateNameForContact(personid, name) {
  var requestData = createBasicRequestData();

  requestData.personid = personid;
  requestData.name = name;

  return requestTo(EventifyAPIConstants.person.nexus, EventifyAPIConstants.person.updateNameForContact, requestData);
}

export async function getPersonById(personid) {
  var requestData = createBasicRequestData();

  requestData.personid = personid;

  return requestTo(EventifyAPIConstants.person.nexus, EventifyAPIConstants.person.getPersonById, requestData);
}

export async function getListsForPersonId(personid) {
  var requestData = createBasicRequestData();

  requestData.personid = personid;

  return requestTo(EventifyAPIConstants.person.nexus, EventifyAPIConstants.person.getListsForPersonId, requestData);
}

export async function getOwnerForPersonId(personid) {
  var requestData = createBasicRequestData();

  requestData.personid = personid;

  return requestTo(EventifyAPIConstants.person.nexus, EventifyAPIConstants.person.getOwnerForPersonId, requestData);
}

export async function getNotesforPersonId(personid) {
  var requestData = createBasicRequestData();

  requestData.personid = personid;

  return requestTo(EventifyAPIConstants.person.nexus, EventifyAPIConstants.person.getNotesforPersonId, requestData);
}

//---------------------------------------------------------------------
// AFFINITY
export async function grabAffinityDateForPerson(name, email) {
  const fullName = name;
  const nameComponents = fullName.split(" ");
  const firstName = nameComponents[0];
  const lastName = nameComponents.slice(1, nameComponents.length).join(" ");

  const url = getRoot(environmentSingleton()) + EventifyAPIConstants.affinityProxy.person + "?term=" + firstName + "+" + lastName + "&email=" + email
  const result = await fetch(url, {
    method: 'get',
  });

  if (!result.ok) throw new Error(result.statusText);
  return result.json();
}

//---------------------------------------------------------------------
// INVITED USERS
export async function createInvitedUser({name, email}) {
  let requestData = createBasicRequestData();
  requestData.name = name;
  requestData.email = email;

  return requestTo(EventifyAPIConstants.invitedUser.nexus, EventifyAPIConstants.invitedUser.create, requestData);
}
export async function getInvitedUserByEmail(email) {
  let requestData = {email: email};

  return requestTo(EventifyAPIConstants.invitedUser.nexus, EventifyAPIConstants.invitedUser.getByEmail, requestData);
}

//---------------------------------------------------------------------
// USERS
export async function authenticateGoogleSignIn(googleSignInInfo) {

  const profileObj = googleSignInInfo.profileObj;

  const fullName = profileObj.name;
  const firstName = profileObj.givenName;
  const lastName = profileObj.familyName;
  const googleId = profileObj.googleId;
  const picture = profileObj.imageUrl;
  const email = profileObj.email;
  const accessToken = googleSignInInfo.accessToken;
  const tokenId = googleSignInInfo.tokenId;

  const requestData = {
    fullName: fullName,
    firstName: firstName,
    lastName: lastName,
    googleId: googleId,
    picture: picture,
    email: email,
    accessToken: accessToken,
    tokenId: tokenId,
    providerType: "google"
  };

  const url = getRoot(environmentSingleton()) + EventifyAPIConstants.user.authenticateGoogleSignIn;
  const result = await fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestData)
  });

  if (!result.ok) throw new Error(await result.text());
  return result.json();
}

export async function getUserById(useridTarget) {
  var requestData = createBasicRequestData();

  const url = getRoot(environmentSingleton()) + EventifyAPIConstants.user.getUserById + "?useridTarget=" + useridTarget + "&userid=" + requestData.userid + "&organizationid=" + requestData.organizationid;

  countRoute(EventifyAPIConstants.user.getUserById);

  const result = await fetch(url, {
    method: 'GET',
  });

  if (!result.ok) throw new Error(result.statusText);
  return result.json();
}

export async function getAllUsers(email, organizationid) {
  var requestData = createBasicRequestData();

  return requestTo(EventifyAPIConstants.user.nexus, EventifyAPIConstants.user.getAllUsers, requestData);
}

// HISTORY
export async function getAllHistoryForOrganization(email, organizationid) {
  var requestData = createBasicRequestData();

  return requestTo(EventifyAPIConstants.history.nexus, EventifyAPIConstants.history.getAllHistoryForOrganization, requestData);
}

export async function getHistoryForListId(listid) {
  var requestData = createBasicRequestData();

  requestData.listid = listid;

  return requestTo(EventifyAPIConstants.history.nexus, EventifyAPIConstants.history.getHistoryForListId, requestData);
}
